import React from 'react';
import { Field, Form, reduxForm } from 'redux-form';
import styles from '../../styles/forms/edit_my_company_member_employment_days_group_wizard/EditMyCompanyMemberEmploymentDaysGroupForm.scss';
import Button from '../../components/Button';
import { __, setTableParams } from '../../core/utils';
import { withRouter } from 'react-router';
import { subscribe } from 'react-contextual/dist/react-contextual.es';
import Localization from '../../helpers/Localization';
import * as _ from 'lodash';
import Input from '../../components/Input';
import { connect } from 'react-redux';
import DateTimePicker from '../../components/DateTimePicker';

const EditMyCompanyMemberEmploymentDaysFutureGroupForm = ({
  handleSubmit,
  submitting,
  localization,
}) => {
  return (
    <Form onSubmit={handleSubmit} className={styles.wrapper}>
      <div className={styles.form}>
        <div className={styles.flex}>
          <div className={styles.f1}>
            <Field
              name='monday_minutes'
              component={Input}
              label={__('my_company_members.flyout.monday_minutes')}
              hint={__('table.columns.hint.in-hours')}
              numeric
              maxLength={2}
            />
          </div>
          <div className={styles.f1}>
            <Field
              name='tuesday_minutes'
              component={Input}
              label={__('my_company_members.flyout.tuesday_minutes')}
              hint={__('table.columns.hint.in-hours')}
              numeric
              maxLength={2}
            />
          </div>
          <div className={styles.f1}>
            <Field
              name='wednesday_minutes'
              component={Input}
              label={__('my_company_members.flyout.wednesday_minutes')}
              hint={__('table.columns.hint.in-hours')}
              numeric
              maxLength={2}
            />
          </div>
        </div>
        <div className={styles.flex}>
          <div className={styles.f1}>
            <Field
              name='thursday_minutes'
              component={Input}
              label={__('my_company_members.flyout.thursday_minutes')}
              hint={__('table.columns.hint.in-hours')}
              numeric
              maxLength={2}
            />
          </div>
          <div className={styles.f1}>
            <Field
              name='friday_minutes'
              component={Input}
              label={__('my_company_members.flyout.friday_minutes')}
              hint={__('table.columns.hint.in-hours')}
              numeric
              maxLength={2}
            />
          </div>
          <div className={styles.f1}>
            <Field
              name='saturday_minutes'
              component={Input}
              label={__('my_company_members.flyout.saturday_minutes')}
              hint={__('table.columns.hint.in-hours')}
              numeric
              maxLength={2}
            />
          </div>
        </div>
        <div className={styles.flex}>
          <div className={styles.f1}>
            <Field
              name='sunday_minutes'
              component={Input}
              label={__('my_company_members.flyout.sunday_minutes')}
              hint={__('table.columns.hint.in-hours')}
              numeric
              maxLength={2}
            />
          </div>
          <div className={styles.f1} />
          <div className={styles.f1} />
        </div>
        <div className={styles.flex}>
          <div className={styles.f1}>
            <Field
              name='hours_start_date'
              component={DateTimePicker}
              label={__('my_company_members.flyout.hours_start_date')}
              footer
            />
          </div>
          <div className={styles.f1}>
            <Field
              name='hours_end_date'
              component={DateTimePicker}
              label={__('my_company_members.flyout.hours_end_date')}
              footer
            />
          </div>
          <div className={styles.f1}></div>
        </div>
      </div>

      <div className={styles.footer}>
        <Button
          lightGray
          medium
          left
          middleText={__('button.cancel')}
          onClick={() =>
            setTableParams('my_company_members', {
              edit_my_company_member_employment_days_group_wizard: undefined,
            })
          }
        />
        <Button
          lightBlue
          medium
          right
          submit
          middleText={__('button.edit')}
          spinning={submitting}
        />
      </div>
    </Form>
  );
};

const mapStateToProps = (state) => {
  return {
    store: _.get(state.table, 'my_company_members'),
  };
};

export default withRouter(
  reduxForm({
    form: 'edit_my_company_member_employment_days_group_wizard.edit_my_company_member_employment_days_future_group',
  })(
    connect(
      mapStateToProps,
      null
    )(
      subscribe(
        Localization,
        'localization'
      )(EditMyCompanyMemberEmploymentDaysFutureGroupForm)
    )
  )
);
